import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import search1 from "../../../Components/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import toast, { Toaster } from "react-hot-toast";
import { Button } from "react-bootstrap";
import { IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import { useLoader } from "../../../utils/common";
import ExternalOrderSearchInput from "./ExternalOrderSearchInput";
import SupplierSearchInput from "./SupplierSearchInput";
import { putData } from "../../../utils/api";
library.add(fas);

// Contacted renders right after ETA, on its own.
const CONTACTED_FIELD = {
  key: "contacted",
  label: "Contacted",
  width: "100px",
};
// const { sendWatsappMessage } = require("../../../../../helper/WhatsAppMessage");
// Customer-facing WhatsApp copy for the toggles.
// const WHATSAPP_MESSAGE_BUILDERS = {
//   ready_for_delivery: (ctx) => `
// 📦 𝗬𝗼𝘂𝗿 𝗢𝗿𝗱𝗲𝗿 𝗶𝘀 𝗥𝗲𝗮𝗱𝘆 𝗳𝗼𝗿 𝗗𝗲𝗹𝗶𝘃𝗲𝗿𝘆 — Bapat Optics ✅

// Hey ${ctx.customerName} 👋

// Good news! Your order is ready for delivery.

// 🧾 Order Details
// 🆔 Sales Invoice No: ${ctx.invoiceNo}
// 🕶️ Product: ${ctx.productName}

// We'll reach out shortly to schedule the delivery.

// 💛 Warm Regards,
// Bapat Optics
// 👓 Quality Vision, Trusted Care`,

//   customer_contacted: (ctx) => `
// 📞 𝗪𝗲'𝘃𝗲 𝗧𝗿𝗶𝗲𝗱 𝗥𝗲𝗮𝗰𝗵𝗶𝗻𝗴 𝗬𝗼𝘂 — Bapat Optics

// Hey ${ctx.customerName} 👋

// We contacted you regarding your order below. If you missed our call, please get back to us at your convenience.

// 🧾 Order Details
// 🆔 Sales Invoice No: ${ctx.invoiceNo}
// 🕶️ Product: ${ctx.productName}

// 💛 Warm Regards,
// Bapat Optics
// 👓 Quality Vision, Trusted Care`,

//   delivered_to_customer: (ctx) => `
// 📦 𝗬𝗼𝘂𝗿 𝗢𝗿𝗱𝗲𝗿 𝗛𝗮𝘀 𝗕𝗲𝗲𝗻 𝗗𝗲𝗹𝗶𝘃𝗲𝗿𝗲𝗱 — Bapat Optics ✅

// Hey ${ctx.customerName} 👋

// Your order has been successfully delivered. 🎉

// 🧾 Order Details
// 🆔 Sales Invoice No: ${ctx.invoiceNo}
// 🕶️ Product: ${ctx.productName}
// 📅 Delivered On: ${ctx.deliveredDate}

// ✨ We hope you enjoy your purchase!
// Thank you for shopping with us.

// 💛 Warm Regards,
// Bapat Optics
// 👓 Quality Vision, Trusted Care`,
// };
// These two render right after Goods Received Date.
const TOGGLE_FIELDS_AFTER_GOODS_RECEIVED = [
  {
    key: "material_received",
    label: (
      <>
        Material
        <br />
        Received
      </>
    ),
    width: "100px",
  },
  {
    key: "assembly_in_progress",
    label: (
      <>
        Assembly in
        <br />
        Progress
      </>
    ),
    width: "110px",
  },
];

// Ready for Delivery -> Customer Contacted -> Delivered to Customer, in order.
const TOGGLE_FIELDS_END = [
  {
    key: "ready_for_delivery",
    label: (
      <>
        Ready for
        <br />
        Delivery
      </>
    ),
    width: "100px",
  },
  {
    key: "customer_contacted",
    label: (
      <>
        Customer
        <br />
        Contacted
      </>
    ),
    width: "120px",
  },
  {
    key: "delivered_to_customer",
    label: (
      <>
        Delivered to
        <br />
        Customer
      </>
    ),
    width: "120px",
  },
];

// Maps a toggle key to the date field (returned by the API) shown under it.
const TOGGLE_DATE_FIELDS = {
  ready_for_delivery: "ready_for_delivery_date",
  customer_contacted: "customer_contacted_date",
  delivered_to_customer: "delivered_to_customer_date",
};

// Editable numeric columns. GST Amount
const EDITABLE_NUMBER_FIELDS = ["wlp", "gst_percent"];

// Editable plain-text columns
const EDITABLE_TEXT_FIELDS = ["invoice_no", "order_no"];

const formatDateForInput = (value) => {
  if (!value) return "";
  return String(value).slice(0, 10);
};

// Short display form (dd/mm/yyyy) for the read-only date shown under a toggle.
const formatDisplayDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}/${d.getFullYear()}`;
};

// GST Amount = WLP * GST% / 100,
const computeGstAmount = (wlp, gstPercent) => {
  const wlpNum = parseFloat(wlp);
  const gstNum = parseFloat(gstPercent);
  if (Number.isNaN(wlpNum) || Number.isNaN(gstNum)) return "";
  return (wlpNum * gstNum) / 100;
};

const ExternalOrder = () => {
  const { getData, postData, Per_Page_Dropdown, isAllow } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  // Date range filter
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [fieldEdits, setFieldEdits] = useState({});

  const [pendingSupplierNames, setPendingSupplierNames] = useState({});

  const { loading, withLoader } = useLoader();
  const handleSelectSearchSuggestion = (item) => {
    setSearch(item.name);
    setonPageChange(1);
    getDataAll(item.name);
  };
  const getDataAll = async (termOverride) => {
    const searchTerm = termOverride !== undefined ? termOverride : search;
    try {
      const response = await withLoader(() =>
        getData(
          `/admin/orders/external-order?page=${onPageChange}&per_page=${perPage}&term=${searchTerm}&from_date=${fromDate}&to_date=${toDate}`,
        ),
      );
      setData(response);
      setCurrentPage(response?.data?.current_page);
      setperPage(response?.data?.per_page);
      setSearch(response?.data?.search_name);
      settotalPages(response?.data?.total_pages);
    } catch (error) {
      console.error("getDataAll error:", error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  // ----- Inline editable-field helpers -----

  const handleFieldChange = (id, field, value) => {
    setFieldEdits((prev) => ({ ...prev, [`${id}-${field}`]: value }));
  };

  const getFieldValue = (d, field) => {
    const key = `${d.id}-${field}`;
    return fieldEdits[key] !== undefined ? fieldEdits[key] : (d?.[field] ?? "");
  };

  const clearFieldEdits = (id, fields) => {
    setFieldEdits((prev) => {
      const updated = { ...prev };
      fields.forEach((f) => delete updated[`${id}-${f}`]);
      return updated;
    });
  };

  // (No -> Yes,
  const applyLocalUpdate = (id, updates) => {
    setData((prev) => {
      if (!prev?.data?.data) return prev;
      return {
        ...prev,
        data: {
          ...prev.data,
          data: prev.data.data.map((row) =>
            row.id === id ? { ...row, ...updates } : row,
          ),
        },
      };
    });
  };

  // ----- Toggle handlers -----

  const handleContactedToggle = async (d) => {
    if (d?.contacted) return; // already committed — irreversible
    const supplierId = getFieldValue(d, "supplier_id");
    const orderDate = getFieldValue(d, "order_date");
    const eta = getFieldValue(d, "eta");

    if (!supplierId || !orderDate || !eta) {
      toast.error(
        "Please fill Supplier, Order Date and ETA before marking Contacted.",
      );
      return;
    }

    try {
      const response = await withLoader(() =>
        postData(`/admin/orders/external-order/${d.id}/contacted`, {
          supplier_id: supplierId,
          order_date: orderDate,
          eta,
        }),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Contacted status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, {
        contacted: true,
        supplier_id: supplierId,
        supplier: pendingSupplierNames[d.id] ?? d?.supplier,
        order_date: orderDate,
        eta,
      });
      clearFieldEdits(d.id, ["supplier_id", "order_date", "eta"]);
      setPendingSupplierNames((prev) => {
        const updated = { ...prev };
        delete updated[d.id];
        return updated;
      });
      getDataAll();
    } catch (error) {
      console.error("Error updating contacted status:", error);
      toast.error("Failed to update Contacted status. Please try again.");
    }
  };

  const handleMaterialReceivedToggle = async (d) => {
    if (d?.material_received) return;
    const wlp = getFieldValue(d, "wlp");
    const gstPercent = getFieldValue(d, "gst_percent");
    const invoiceNo = getFieldValue(d, "invoice_no");
    const orderNo = getFieldValue(d, "order_no");
    const goodsReceivedDate = getFieldValue(d, "goods_received_date");

    if (!wlp || !gstPercent || !invoiceNo || !orderNo || !goodsReceivedDate) {
      toast.error(
        "Please fill WLP, GST%, Invoice No, Order No and Goods Received Date before marking Material Received.",
      );
      return;
    }

    // Receiving quantity is always 1 for external orders.
    const receiveQuantity = 1;
    const price = parseFloat(wlp) || 0;
    const totalPrice = (receiveQuantity * price).toFixed(2);
    const gstAmount = computeGstAmount(wlp, gstPercent); // existing helper

    // No UI fields for these yet — always 0
    const wlpDiscount = 0;
    const wlpDiscountAmount = 0;
    const basePrice = (parseFloat(wlp) || 0) - wlpDiscountAmount;

    const quantity = [
      {
        id: d?.purchase_order_product_id,
        product_id: d?.product_id,
        quantity: receiveQuantity,
        description: "Stock add by Order Tracking",
        price,
        total_price: totalPrice,
        models: [],
      },
    ];

    const DataToSend = new FormData();
    DataToSend.append("id", d?.Pr_o_id);
    DataToSend.append("total_quantity", receiveQuantity);
    DataToSend.append("total_price", totalPrice);
    DataToSend.append("batch_no", d?.batch_no || "");
    DataToSend.append("order_no", orderNo);
    DataToSend.append("invoice_no", invoiceNo);
    DataToSend.append("supplier_id", d?.supplier_id);
    DataToSend.append("quantitys", JSON.stringify(quantity));

    // Available from frontend
    DataToSend.append("gst", gstPercent || 0);
    DataToSend.append("gst_price", gstAmount || 0);
    DataToSend.append("wlp", wlp || 0);
    DataToSend.append("receiving_date", goodsReceivedDate || "");

    // Not available from frontend
    DataToSend.append("wlpdiscount", wlpDiscount);
    DataToSend.append("wlpdiscountamount", wlpDiscountAmount);
    DataToSend.append("base_price", basePrice);

    try {
      const receivingResponse = await withLoader(() =>
        putData(
          `/admin/purchase-order/purchase-product/receiving/${d?.Pr_o_id}`,
          DataToSend,
        ),
      );

      if (!receivingResponse?.success) {
        toast.error(
          receivingResponse?.message ||
            "Failed to create receiving record. Please try again.",
        );
        return;
      }

      // ----- -----
      const statusResponse = await withLoader(() =>
        postData(`/admin/orders/external-order/${d.id}/material_received`, {
          wlp,
          gst_percent: gstPercent,
          invoice_no: invoiceNo,
          order_no: orderNo,
          goods_received_date: goodsReceivedDate,
        }),
      );

      if (!statusResponse || statusResponse.success === false) {
        toast.error(
          statusResponse?.message ||
            "Receiving was created, but marking Material Received failed. Please refresh and try again.",
        );
        return;
      }

      setChangeStatus(statusResponse);
      applyLocalUpdate(d.id, {
        material_received: true,
        wlp,
        gst_percent: gstPercent,
        gst_amount: computeGstAmount(wlp, gstPercent),
        invoice_no: invoiceNo,
        order_no: orderNo,
        goods_received_date: goodsReceivedDate,
      });
      clearFieldEdits(d.id, [
        "wlp",
        "gst_percent",
        "invoice_no",
        "order_no",
        "goods_received_date",
      ]);
      getDataAll();
    } catch (error) {
      console.error("Error updating material received status:", error);
      toast.error(
        "Failed to update Material Received status. Please try again.",
      );
    }
  };

  const handleAssemblyInProgressToggle = async (d) => {
    if (d?.assembly_in_progress) return;

    if (!d?.material_received) {
      toast.error(
        "Please turn on Material Received before marking Assembly in Progress.",
      );
      return;
    }

    try {
      const response = await withLoader(() =>
        postData(
          `/admin/orders/external-order/${d.id}/assembly_in_progress`,
          {},
        ),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Assembly in Progress status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, { assembly_in_progress: true });
      getDataAll();
    } catch (error) {
      console.error("Error updating assembly in progress status:", error);
      toast.error(
        "Failed to update Assembly in Progress status. Please try again.",
      );
    }
  };

  // ----- Ready for Delivery -----
  const handleReadyForDeliveryToggle = async (d) => {
    if (d?.ready_for_delivery) return;

    if (!d?.assembly_in_progress) {
      toast.error(
        "Please turn on Assembly in Progress before marking Ready for Delivery.",
      );
      return;
    }

    try {
      const response = await withLoader(() =>
        postData(`/admin/orders/external-order/${d.id}/ready_for_delivery`, {}),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Ready for Delivery status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, {
        ready_for_delivery: true,
        ready_for_delivery_date: new Date().toISOString(),
      });
      getDataAll();
    } catch (error) {
      console.error("Error updating ready for delivery status:", error);
      toast.error(
        "Failed to update Ready for Delivery status. Please try again.",
      );
    }
  };

  const handleCustomerContactedToggle = async (d) => {
    if (d?.customer_contacted) return;
    try {
      const response = await withLoader(() =>
        postData(`/admin/orders/external-order/${d.id}/customer_contacted`, {}),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Customer Contacted status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, {
        customer_contacted: true,
        customer_contacted_date: new Date().toISOString(),
      });
      getDataAll();
    } catch (error) {
      console.error("Error updating customer contacted status:", error);
      toast.error(
        "Failed to update Customer Contacted status. Please try again.",
      );
    }
  };

  // ----- Delivered to Customer
  const handleDeliveredToCustomerToggle = async (d) => {
    if (d?.delivered_to_customer) return;

    if (!d?.ready_for_delivery) {
      toast.error(
        "Please turn on Ready for Delivery before marking Delivered to Customer.",
      );
      return;
    }

    try {
      const response = await withLoader(() =>
        postData(
          `/admin/orders/external-order/${d.id}/delivered_to_customer`,
          {},
        ),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Delivered to Customer status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, {
        delivered_to_customer: true,
        delivered_to_customer_date: new Date().toISOString(),
      });
      getDataAll();
    } catch (error) {
      console.error("Error updating delivered to customer status:", error);
      toast.error(
        "Failed to update Delivered to Customer status. Please try again.",
      );
    }
  };

  const TOGGLE_HANDLERS = {
    contacted: handleContactedToggle,
    material_received: handleMaterialReceivedToggle,
    assembly_in_progress: handleAssemblyInProgressToggle,
    ready_for_delivery: handleReadyForDeliveryToggle,
    customer_contacted: handleCustomerContactedToggle,
    delivered_to_customer: handleDeliveredToCustomerToggle,
  };

  //  toggle's

  const TOGGLE_REQUIREMENTS = {
    contacted: {
      fields: ["supplier_id", "order_date", "eta"],
      message: "Fill Supplier, Order Date and ETA to enable",
    },
    material_received: {
      fields: [
        "wlp",
        "gst_percent",
        "invoice_no",
        "order_no",
        "goods_received_date",
      ],
      message:
        "Fill WLP, GST%, Invoice No, Order No and Goods Received Date to enable",
    },

    assembly_in_progress: {
      fields: [],
      booleanFields: ["material_received"],
      message: "Turn on Material Received first",
    },
    ready_for_delivery: {
      fields: [],

      booleanFields: ["assembly_in_progress"],
      message: "Turn on Assembly in Progress first",
    },
    customer_contacted: {
      fields: [],
      message: "",
    },
    delivered_to_customer: {
      fields: [],

      booleanFields: ["ready_for_delivery"],
      message: "Turn on Ready for Delivery first",
    },
  };

  const isToggleReady = (d, key) => {
    const requirement = TOGGLE_REQUIREMENTS[key];
    if (!requirement) return true;

    const fieldsReady = requirement.fields.every((field) => {
      const value = getFieldValue(d, field);
      return value !== undefined && value !== null && value !== "";
    });

    const booleanFieldsReady = (requirement.booleanFields || []).every(
      (field) => !!d?.[field],
    );

    return fieldsReady && booleanFieldsReady;
  };

  const renderToggleCell = (field, d) => {
    const isOn = !!d?.[field.key];
    const ready = isToggleReady(d, field.key);
    const handler = TOGGLE_HANDLERS[field.key];
    const dateField = TOGGLE_DATE_FIELDS[field.key];
    const savedDate = dateField ? formatDisplayDate(d?.[dateField]) : "";

    const tdTitle =
      field.key === "customer_contacted" &&
      (d?.customer_name || d?.customer_contact_no)
        ? `Name: ${d?.customer_name || "N/A"}\nContact: ${d?.customer_contact_no || "N/A"}`
        : undefined;

    return (
      <td key={field.key} title={tdTitle}>
        <div
          className="form-check form-switch"
          title={
            !isOn && !ready
              ? TOGGLE_REQUIREMENTS[field.key]?.message
              : undefined
          }
        >
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={isOn}
            disabled={!isAllow?.includes(51) || isOn || !ready}
            onChange={() => handler(d)}
            id={`${field.key}${d?.id}`}
          />
          <label className="form-check-label" htmlFor={`${field.key}${d?.id}`}>
            {isOn ? "Yes" : "No"}
          </label>
        </div>
        {isOn && savedDate && (
          <div
            className="toggle-saved-date"
            style={{ fontSize: "11px", marginTop: "2px", color: "#555" }}
          >
            {savedDate}
          </div>
        )}
      </td>
    );
  };
  // ---------------------------------------------------------------------

  const handleReset = () => {
    setSearch("");
    setFromDate("");
    setToDate("");
    setFieldEdits({});
    setPendingSupplierNames({});
    setReset(!reset);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    sr_no: true,
    sales_invoice_no: true,
    product_details: true,
    supplier: true,
    order_date: true,
    eta: true,
    contacted: true,
    wlp: true,
    gst_percent: true,
    gst_amount: true,
    invoice_no: true,
    order_no: true,
    goods_received_date: true,
    material_received: true,
    assembly_in_progress: true,
    ready_for_delivery: true,
    customer_contacted: true,
    delivered_to_customer: true,

    customer_name: false,
    customer_contact_no: false,
  });

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"External Order"}
          link={"/admin/orders/external-order"}
        />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio">
                <div className="">
                  {/* container */}
                  <div className="row">
                    <div className="border-line mt-3"></div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="row align-items-start">
                          {/* Date range filter */}
                          <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-2">
                            <label className="form-label">From Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={fromDate}
                              onChange={(e) => setFromDate(e.target.value)}
                            />
                          </div>
                          <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-2">
                            <label className="form-label">To Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={toDate}
                              onChange={(e) => setToDate(e.target.value)}
                            />
                          </div>

                          {/* Search name */}
                          <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6  col-sm-6 col-12 mb-2">
                            <label className="form-label"></label>
                            <div className="num">
                              <ExternalOrderSearchInput
                                value={search}
                                onChange={setSearch}
                                onSelect={handleSelectSearchSuggestion}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2  col-sm-6 col-12 mb-2">
                            <label className="form-label"></label>
                            <div className="Search">
                              <Button
                                type="button"
                                onClick={() => {
                                  setonPageChange(1);
                                  getDataAll();
                                }}
                                className="btn btn-search"
                              >
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2  col-sm-6 col-12 mb-2">
                            <label className="form-label"></label>
                            <div className="Search-1">
                              <button
                                type="button"
                                onClick={handleReset}
                                className="btn btn-reset"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table
                        striped
                        bordered
                        hover
                        responsive
                        center
                        style={{ tableLayout: "fixed" }}
                      >
                        <thead>
                          <tr className="">
                            {visible.sr_no && (
                              <th className="sr" style={{ width: "70px" }}>
                                Sr. No.
                              </th>
                            )}
                            {visible.sales_invoice_no && (
                              <th style={{ width: "120px" }}>
                                Sales Invoice No.
                              </th>
                            )}
                            {visible.product_details && (
                              <th style={{ width: "320px" }}>
                                Product Details
                              </th>
                            )}
                            {visible.supplier && (
                              <th style={{ width: "180px" }}>Supplier</th>
                            )}
                            {visible.order_date && (
                              <th style={{ width: "140px" }}>Order Date</th>
                            )}
                            {visible.eta && (
                              <th style={{ width: "140px" }}>ETA</th>
                            )}
                            {visible.contacted && (
                              <th style={{ width: CONTACTED_FIELD.width }}>
                                {CONTACTED_FIELD.label}
                              </th>
                            )}
                            {visible.wlp && (
                              <th style={{ width: "90px" }}>WLP</th>
                            )}
                            {visible.gst_percent && (
                              <th style={{ width: "90px" }}>GST%</th>
                            )}
                            {visible.gst_amount && (
                              <th style={{ width: "100px" }}>
                                GST
                                <br />
                                Amount
                              </th>
                            )}
                            {visible.invoice_no && (
                              <th style={{ width: "180px" }}>Invoice No</th>
                            )}
                            {visible.order_no && (
                              <th style={{ width: "120px" }}>Order No</th>
                            )}
                            {visible.goods_received_date && (
                              <th style={{ width: "160px" }}>
                                Goods Received Date
                              </th>
                            )}
                            {TOGGLE_FIELDS_AFTER_GOODS_RECEIVED.map(
                              (field) =>
                                visible[field.key] && (
                                  <th
                                    key={field.key}
                                    style={{ width: field.width }}
                                  >
                                    {field.label}
                                  </th>
                                ),
                            )}

                            {TOGGLE_FIELDS_END.map(
                              (field) =>
                                visible[field.key] && (
                                  <th
                                    key={field.key}
                                    style={{ width: field.width }}
                                  >
                                    {field.label}
                                  </th>
                                ),
                            )}

                            {visible.customer_name && (
                              <th style={{ width: "140px" }}>Customer Name</th>
                            )}

                            {visible.customer_contact_no && (
                              <th style={{ width: "140px" }}>
                                Customer Contact No
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.data?.map((d, index) => {
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + index + 1;
                            const liveGstAmount = computeGstAmount(
                              getFieldValue(d, "wlp"),
                              getFieldValue(d, "gst_percent"),
                            );
                            return (
                              <tr className="" key={index}>
                                {visible.sr_no && <td>{paginatedIndex}.</td>}

                                {visible.sales_invoice_no && (
                                  <td
                                    title={
                                      d?.customer_name || d?.customer_contact_no
                                        ? `Name: ${d?.customer_name || "N/A"}\nContact: ${d?.customer_contact_no || "N/A"}`
                                        : undefined
                                    }
                                  >
                                    {d?.sales_invoice_no}
                                  </td>
                                )}

                               {visible.product_details && (
  <td
    className="width_dertails_name_div"
    style={{
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "anywhere",
      maxWidth: "320px",
    }}
  >
    {d?.product_details}
  </td>
)}

                                {/* Supplier  */}
                                {visible.supplier && (
                                  <td>
                                    <SupplierSearchInput
                                      currentName={
                                        pendingSupplierNames[d.id] ??
                                        d?.supplier
                                      }
                                      disabled={!!d?.contacted}
                                      onSelect={(supplier) => {
                                        if (d?.contacted) return;
                                        handleFieldChange(
                                          d.id,
                                          "supplier_id",
                                          supplier.id,
                                        );
                                        setPendingSupplierNames((prev) => ({
                                          ...prev,
                                          [d.id]: supplier.name,
                                        }));
                                      }}
                                    />
                                  </td>
                                )}

                                {/* Order Date, ETA */}
                                {["order_date", "eta"].map(
                                  (field) =>
                                    visible[field] && (
                                      <td key={field}>
                                        <input
                                          type="date"
                                          className="form-control form-control-sm"
                                          style={{ width: "100%" }}
                                          value={formatDateForInput(
                                            getFieldValue(d, field),
                                          )}
                                          disabled={!!d?.contacted}
                                          onChange={(e) =>
                                            handleFieldChange(
                                              d.id,
                                              field,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                    ),
                                )}

                                {/* Contacted */}
                                {visible.contacted &&
                                  renderToggleCell(CONTACTED_FIELD, d)}

                                {/* WLP, GST% */}
                                {EDITABLE_NUMBER_FIELDS.map(
                                  (field) =>
                                    visible[field] && (
                                      <td key={field}>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          style={{ width: "100%" }}
                                          value={getFieldValue(d, field)}
                                          min={0}
                                          max={
                                            field === "gst_percent"
                                              ? 100
                                              : undefined
                                          }
                                          disabled={!!d?.material_received}
                                          onChange={(e) => {
                                            let val = e.target.value;
                                            if (
                                              field === "gst_percent" &&
                                              val !== "" &&
                                              Number(val) > 100
                                            ) {
                                              val = "100";
                                            }
                                            handleFieldChange(d.id, field, val);
                                          }}
                                        />
                                      </td>
                                    ),
                                )}

                                {/* GST Amount — auto-calculated (WLP * GST% / 100), */}
                                {visible.gst_amount && (
                                  <td>
                                    {liveGstAmount !== ""
                                      ? Number(liveGstAmount).toFixed(2)
                                      : d?.gst_amount != null
                                        ? Number(d.gst_amount).toFixed(2)
                                        : "-"}
                                  </td>
                                )}

                                {/* Invoice No, Order No */}
                                {EDITABLE_TEXT_FIELDS.map(
                                  (field) =>
                                    visible[field] && (
                                      <td
                                        key={field}
                                        title={
                                          field === "invoice_no" &&
                                          (d?.customer_name ||
                                            d?.customer_contact_no)
                                            ? `Name: ${d?.customer_name || "N/A"}\nContact: ${d?.customer_contact_no || "N/A"}`
                                            : undefined
                                        }
                                      >
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          style={{ width: "100%" }}
                                          value={getFieldValue(d, field)}
                                          disabled={!!d?.material_received}
                                          onChange={(e) =>
                                            handleFieldChange(
                                              d.id,
                                              field,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                    ),
                                )}

                                {/* Goods Received Date */}
                                {visible.goods_received_date && (
                                  <td>
                                    <input
                                      type="date"
                                      className="form-control form-control-sm"
                                      style={{ width: "100%" }}
                                      value={formatDateForInput(
                                        getFieldValue(d, "goods_received_date"),
                                      )}
                                      disabled={!!d?.material_received}
                                      onChange={(e) =>
                                        handleFieldChange(
                                          d.id,
                                          "goods_received_date",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </td>
                                )}

                                {/* Material Received, Assembly in Progress */}
                                {TOGGLE_FIELDS_AFTER_GOODS_RECEIVED.map(
                                  (field) =>
                                    visible[field.key] &&
                                    renderToggleCell(field, d),
                                )}

                                {/* Delivered Date column removed */}

                                {/* Ready for Delivery, Customer Contacted, Delivered to Customer */}
                                {TOGGLE_FIELDS_END.map(
                                  (field) =>
                                    visible[field.key] &&
                                    renderToggleCell(field, d),
                                )}

                                {/* customer_name */}
                                {visible.customer_name && (
                                  <td>{d?.customer_name}</td>
                                )}

                                {/* customer_contact_no */}
                                {visible.customer_contact_no && (
                                  <td>{d?.customer_contact_no}</td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <Toaster position="top-right" />
    </>
  );
};

export default ExternalOrder;
